import React, { useState } from "react";
import VoiceComponent from "../components/VoiceComponent";
var Widget = function (_a) {
    var _b;
    var _c, _d, _e, _f, _g;
    var config = _a.config;
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    var _h = useState(false), isOpen = _h[0], setIsOpen = _h[1];
    var _j = useState({
        horizontal: ((_c = config === null || config === void 0 ? void 0 : config.position) === null || _c === void 0 ? void 0 : _c.side) || 'right',
        vertical: 'bottom'
    }), inset = _j[0], setInset = _j[1];
    var toggleChat = function () {
        setIsOpen(!isOpen);
    };
    React.useEffect(function () {
        document.documentElement.setAttribute("data-theme", (config === null || config === void 0 ? void 0 : config.theme) || 'light');
    }, [config === null || config === void 0 ? void 0 : config.theme]);
    return (React.createElement("div", { className: "widget", style: {
            position: 'fixed',
            left: 0,
            top: 0,
            userSelect: 'none',
            zIndex: 9999,
            pointerEvents: 'auto',
            width: isMobile && isOpen ? '100%' : 'auto',
            maxWidth: isMobile ? '100%' : '400px'
        } },
        React.createElement(VoiceComponent, { position: {
                side: inset.horizontal,
                verticalAlign: inset.vertical,
                offset: (_b = {},
                    _b[inset.vertical] = '20px',
                    _b[inset.horizontal] = '20px',
                    _b)
            }, header: config === null || config === void 0 ? void 0 : config.header, isOpen: isOpen, onClose: function () { return setIsOpen(false); }, onToggle: toggleChat, email: ((_d = config === null || config === void 0 ? void 0 : config.livekit) === null || _d === void 0 ? void 0 : _d.email) || 'user@example.com', language: ((_e = config === null || config === void 0 ? void 0 : config.livekit) === null || _e === void 0 ? void 0 : _e.language) || 'en', domain: ((_f = config === null || config === void 0 ? void 0 : config.livekit) === null || _f === void 0 ? void 0 : _f.domain) || 'default', mode: ((_g = config === null || config === void 0 ? void 0 : config.livekit) === null || _g === void 0 ? void 0 : _g.mode) || 'voice' })));
};
export default Widget;
